import React, { useEffect, useState } from 'react';
import CloseButton from '../components/CloseButton';
import BackButton from '../components/BackButton';

import SugarAddPanel from './diabetes/SugarAddPanel';
import SugarListPanel from './diabetes/SugarListPanel';
import InsulinAddPanel from './diabetes/InsulinAddPanel';
import InsulinListPanel from './diabetes/InsulinListPanel';
import BaseAddPanel from './diabetes/BaseAddPanel';
import BaseListPanel from './diabetes/BaseListPanel';
import VortioxetineAddPanel from './other/VortioxetineAddPanel';
import VortioxetineListPanel from './other/VortioxetineListPanel';
import DailyEventsAddPanel from './other/DailyEventsAddPanel';
import DailyEventsPanel from './other/DailyEventsPanel';
import RegisteredEventsTypeAddPanel from './other/RegisteredEventsTypeAddPanel';
import RegisteredEventsTypePanel from './other/RegisteredEventsTypePanel';
import WorkoutAddPanel from './other/WorkoutAddPanel';
import WorkoutListPanel from './other/WorkoutListPanel';
import FoodIntakePanel from './food/FoodIntakePanel';
import FoodIntakeTemplateListPanel from './food/FoodIntakeTemplateListPanel';

export default function HealthDataManager({ onClose }) {
  // Panel state - tracks which sub-panel is open
  const [activePanel, setActivePanel] = useState(null);

  // Responsive sizing
  const [panelSize, setPanelSize] = useState({ width: 420 });
  useEffect(() => {
    function handleResize() {
      const w = Math.min(window.innerWidth - 32, 520);
      setPanelSize({
        width: Math.max(260, w)
      });
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Dynamic panel height: fits content, up to 96vh
  let contentHeight = 0;
  if (activePanel) {
    // Sub-panel mode: keep same sizing as DiabetesPanel
    contentHeight = Math.min(650, window.innerHeight * 0.85);
  } else {
    // Main menu: header + grid + padding
  contentHeight = 38 + 300 + 44;
  }
  contentHeight = Math.min(contentHeight, window.innerHeight * 0.96);

  const buttonStyle = {
    padding: '12px 16px',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s'
  };

  return (
    <div
      style={{
        background: '#fff',
        padding: '24px 12px 18px 12px',
        borderRadius: 16,
        boxShadow: '0 2px 18px rgba(0,0,0,0.22)',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        minWidth: 0,
        width: `${panelSize.width}px`,
        maxWidth: '98vw',
        minHeight: 0,
        height: `${Math.round(contentHeight)}px`,
        maxHeight: '96vh',
        overflow: 'auto',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <CloseButton
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          zIndex: 10001
        }}
      />

      {/* BackButton - only show when in a sub-panel */}
      {activePanel && (
        <BackButton
          onClick={() => setActivePanel(null)}
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            zIndex: 10001
          }}
        />
      )}

      {/* Conditional content based on active panel */}
      {!activePanel ? (
        <>
          <h2 style={{ marginBottom: 18 }}>🩺 Health Data Manager</h2>

          {/* 2x3 Button Grid */}
          <div
            style={{
              width: '100%',
              maxWidth: 420,
              margin: '20px auto 0 auto',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridTemplateRows: '1fr 1fr 1fr 1fr',
              gap: '12px',
              padding: '0 8px'
            }}
          >
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#36a2eb'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#2591d9')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#36a2eb')}
              onClick={() => setActivePanel('sugar-add')}
            >
              🩸 Sugar Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#36a2eb'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#2591d9')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#36a2eb')}
              onClick={() => setActivePanel('sugar-list')}
            >
              📋 Sugar List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#43ea5e'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#3ad654')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#43ea5e')}
              onClick={() => setActivePanel('insulin-add')}
            >
              💉 Insulin Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#43ea5e'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#3ad654')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#43ea5e')}
              onClick={() => setActivePanel('insulin-list')}
            >
              📋 Insulin List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#f6e96b',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f4e456')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#f6e96b')}
              onClick={() => setActivePanel('base-add')}
            >
              🏠 Base Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#f6e96b',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f4e456')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#f6e96b')}
              onClick={() => setActivePanel('base-list')}
            >
              📋 Base List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#f6e96b',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f4e456')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#f6e96b')}
              onClick={() => setActivePanel('vortioxetine-add')}
            >
              💊 Vortioxetine Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#f6e96b',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#f4e456')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#f6e96b')}
              onClick={() => setActivePanel('vortioxetine-list')}
            >
              📋 Vortioxetine List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#8be5ff',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#74ddff')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#8be5ff')}
              onClick={() => setActivePanel('workout-add')}
            >
              🏋️ Workout Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#8be5ff',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#74ddff')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#8be5ff')}
              onClick={() => setActivePanel('workout-list')}
            >
              📋 Workout List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#8be5ff',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#74ddff')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#8be5ff')}
              onClick={() => setActivePanel('daily-events-add')}
            >
              📅 Daily Events Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#8be5ff',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#74ddff')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#8be5ff')}
              onClick={() => setActivePanel('daily-events-list')}
            >
              📋 Daily Events List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#8be5ff',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#74ddff')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#8be5ff')}
              onClick={() => setActivePanel('registered-events-type-add')}
            >
              🗂️ Event Type Add
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#8be5ff',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#74ddff')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#8be5ff')}
              onClick={() => setActivePanel('registered-events-type-list')}
            >
              📋 Event Type List
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#ffb86b',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#ffa954')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#ffb86b')}
              onClick={() => setActivePanel('food-intake-list')}
            >
              🍽️ Food intake list
            </button>
            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#ffb86b',
                color: '#333',
                opacity: 0.6,
                cursor: 'not-allowed'
              }}
              title="Coming soon"
              onClick={() => {}}
            >
              📚 Food history list
            </button>

            <button
              style={{
                ...buttonStyle,
                backgroundColor: '#ffb86b',
                color: '#333'
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#ffa954')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#ffb86b')}
              onClick={() => setActivePanel('food-template-list')}
            >
              📦 Food templates
            </button>
          </div>
        </>
      ) : (
        <>
          {activePanel === 'sugar-add' && <SugarAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'sugar-list' && <SugarListPanel />}
          {activePanel === 'insulin-add' && <InsulinAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'insulin-list' && <InsulinListPanel />}
          {activePanel === 'base-add' && <BaseAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'base-list' && <BaseListPanel />}
          {activePanel === 'vortioxetine-add' && <VortioxetineAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'vortioxetine-list' && <VortioxetineListPanel />}
          {activePanel === 'workout-add' && <WorkoutAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'workout-list' && <WorkoutListPanel />}
          {activePanel === 'daily-events-add' && <DailyEventsAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'daily-events-list' && <DailyEventsPanel />}
          {activePanel === 'registered-events-type-add' && <RegisteredEventsTypeAddPanel onClose={() => setActivePanel(null)} />}
          {activePanel === 'registered-events-type-list' && <RegisteredEventsTypePanel />}
          {activePanel === 'food-intake-list' && <FoodIntakePanel />}
          {activePanel === 'food-template-list' && <FoodIntakeTemplateListPanel />}
        </>
      )}
    </div>
  );
}
